import { render } from "./vertex-loading-image.vue?vue&type=template&id=a36c53a6&scoped=true"
import script from "./vertex-loading-image.vue?vue&type=script&lang=js"
export * from "./vertex-loading-image.vue?vue&type=script&lang=js"

import "./vertex-loading-image.vue?vue&type=style&index=0&id=a36c53a6&lang=css"
import "./vertex-loading-image.vue?vue&type=style&index=1&id=a36c53a6&scoped=true&lang=css"
import "./vertex-loading-image.vue?vue&type=style&index=2&id=a36c53a6&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a36c53a6"]])

export default __exports__